"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.customerQuery = void 0;
var _fetching = require("@ori/fetching");
const customerQuery = exports.customerQuery = (0, _fetching.gql)`
  query GetCustomer {
    customer {
      firstName
      lastName
      emails {
        emailAddress
      }
      consultantNumber
      customerId
      phones {
        telephoneNumber
      }
      customerType {
        description
      }
    }
  }
`;
